import { Roles } from '@/constants/roles';

/**
 * @typedef {import('@/types/auth').User} UserType
 */
/**
 * Supabaseから取得したuserデータをUserオブジェクトに変換する
 * @param {Object} row
 * @returns {import('@/types/auth/User').User}
 */
export class User {
  /**
   * @param {any} rawUser Supabaseから返ってくる生のユーザーデータ
   */
  constructor(rawUser) {
    if (!rawUser) return;

    this.id = rawUser.id;
    this.email = rawUser.email;
    this.provider = rawUser.app_metadata.provider;

    // メタデータからフラットに抽出
    this.username = rawUser.user_metadata?.full_name || rawUser.user_metadata?.username;
    this.roleId = Number(rawUser.user_metadata?.role_id);
    this.avatarUrl = rawUser.user_metadata?.avatar_url;

    this.createdAt = new Date(rawUser.created_at);
    this.updatedAt = new Date(rawUser.updated_at);
  }

  /**
   * 管理者かどうかを返す
   * @returns {boolean}
   */
  get isAdmin() {
    return this.roleId === Roles.ADMIN.id;
  }

  /**
   * 表示用のユーザー名を取得
   * @returns {string}
   */
  get displayName() {
    const email = this.email ?? '';
    const emailName = email.includes('@') ? email.substring(0, email.indexOf('@')) : email;

    return this.username || emailName;
  }
}
